{
  "content": [
    {
      "id": "led-04",
      "direction": "DEBIT",
      "amount": 500000,
      "category": "FACILITIES",
      "concept": "Mantenimiento Césped e Instalaciones",
      "sourceType": "MAINTENANCE",
      "sourceReference": "MAINT-SEP",
      "recordedAt": "2026-09-18T14:00:00Z",
      "occurredAt": "2026-09-18T14:00:00Z",
      "balanceAfter": 50000000
    },
    {
      "id": "led-03",
      "direction": "DEBIT",
      "amount": 2800000,
      "category": "SALARIES",
      "concept": "Nómina Mensual Plantilla y Staff",
      "sourceType": "PAYROLL",
      "sourceReference": "PAYROLL-SEP",
      "recordedAt": "2026-09-15T08:00:00Z",
      "occurredAt": "2026-09-15T08:00:00Z",
      "balanceAfter": 50500000
    },
    {
      "id": "led-02",
      "direction": "CREDIT",
      "amount": 3200000,
      "category": "TICKETING",
      "concept": "Taquilla Jornada 4",
      "sourceType": "MATCH",
      "sourceReference": "MATCH-04",
      "recordedAt": "2026-09-12T20:30:00Z",
      "occurredAt": "2026-09-12T20:30:00Z",
      "balanceAfter": 53300000
    },
    {
      "id": "led-01",
      "direction": "CREDIT",
      "amount": 15000000,
      "category": "SPONSORSHIP",
      "concept": "Patrocinio Principal Temporada",
      "sourceType": "CONTRACT",
      "sourceReference": "SPONSOR-2026",
      "recordedAt": "2026-09-01T10:00:00Z",
      "occurredAt": "2026-09-01T10:00:00Z",
      "balanceAfter": 50100000
    }
  ],
  "totalElements": 4,
  "totalPages": 1
}
